module.exports = __webpack_public_path__ + "static/media/check.dfeb9ff6.svg";